import { ContainerComponent, wrap } from 'AppReact';
import internalState from './internalState';
import {
  MakeReadyItemCellWrapper, Td, ElementWithPopupWrapper, SpanWrapper, FullWidthHeightJustifyCenter,
  Mr2, Mr1
} from 'wrappers';
import { Initials, ProfileImage, Icon, SecondaryTextXs } from 'atoms';
import { IconTextButton, MultipleProgressBar } from 'molecules';
import { PlusSignSvg, GreenTickSvg, CloseSquareSvg } from 'components/icons';
import controller from './controller';
import { getInitials } from 'utils/getInitials';

export const definition = {
  name: 'TextCell',
  controller,
  initialProps: ({ data, card, makeReadyCategory, inspectionTemplates }) => ({ data, card, makeReadyCategory, inspectionTemplates }),
  props: internalState,
  elements: [
    {
      wrapper: MakeReadyItemCellWrapper,
      name: 'Selector',
      displayState: ({ }) => ({}),
      elements: [
        {
          wrapper: FullWidthHeightJustifyCenter,
          isButton: true,
          name: 'ProgressBar',
          renderIf: ({ data }) => !!data,
          bindings: ({ data }) => ({ id: data.inspection_id }),
          elements: [
            {
              component: Mr1,
              name: 'MarginLeft',
              elements: []
            },
            {
              wrapper: Mr2,
              name: 'ImageWrapper',
              elements: [
                {
                  component: Initials,
                  name: 'Initials',
                  renderIf: ({ data }) => !data?.inspection_assignee_image && data?.inspection_assignee && data?.inspection_status === 'open',
                  displayValue: ({ data }) => getInitials(data.inspection_assignee),
                  displayState: ({ }) => ({ size: 20 })
                },
                {
                  component: ProfileImage,
                  name: 'Image',
                  renderIf: ({ data }) => data?.inspection_assignee_image && data?.inspection_status === 'open',
                  displayValue: ({ data }) => data.inspection_assignee_image,
                  displayState: () => ({ size: 20, primary: true })
                },
                {
                  component: Icon,
                  name: 'Icon',
                  renderIf: ({ data }) => data?.inspection_status && data?.inspection_status !== 'open',
                  displayValue: ({ data }) => data.inspection_status === 'completed' ? GreenTickSvg({ width: 16, height: 16 }) : CloseSquareSvg({ width: 16, height: 16, color: 'red' }),
                },
              ]
            },
            {
              component: MultipleProgressBar,
              name: 'Progress',
              bindings: ({ data }) => ({ total: data.inspection_num_items, started: data.inspection_started_items, completed: data.inspection_completed_items, id: data.inspection_id }),
              displayState: ({ }) => ({ height: '13px' }),
            },
            {
              component: Mr1,
              name: 'MarginRight',
              elements: []
            },
          ]
        },
        {
          wrapper: ElementWithPopupWrapper,
          name: 'HideWrapper',
          renderIf: ({ data, card }) => !data && !card.hidden,
          displayState: ({ }) => ({ width: '100%', height: '100%' }),
          elements: [
            {
              component: wrap(wrap(IconTextButton, FullWidthHeightJustifyCenter), SpanWrapper),
              name: 'AddInspection',
              renderIf: ({ makeReadyCategory, inspectionTemplates }) => !!inspectionTemplates.find(t => t.name === makeReadyCategory.name)?.active,
              bindings: ({ card }) => ({ icon: PlusSignSvg({}), title: 'Create', card })
            },
            {
              component: wrap(wrap(SecondaryTextXs, FullWidthHeightJustifyCenter), SpanWrapper),
              renderIf: ({ makeReadyCategory, inspectionTemplates }) => !inspectionTemplates.find(t => t.name === makeReadyCategory.name)?.active,
              name: 'Text',
              displayValue: ({ }) => 'Deactivated'
            },
          ]
        }
      ]
    },
  ]
}

export default wrap(ContainerComponent(definition), Td)